import React, { Component } from 'react';
import config from '../../../config';

class NotFound extends Component {

  render() {
    const mailto = `mailto:${config.pages.error.support_email}`;
    return (
      <article className="error-message not-found">
        <h1>Page Not Found</h1>
        <section>
          <p>We're sorry, the page you're looking for can't be found at this
          address. Double check your URL, refresh the page, and then contact
          us at <a href={mailto}>{config.pages.error.support_email}</a> if you
          need further assistance.</p>

          <p><a href="/map/nearby-region">View Nearby Region</a></p>
        </section>
      </article>
    );
  }

}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/Errors/NotFound/NotFound.js